import {request} from './index.js'
import { oldPlatform } from './config.js';
// 获取权限
export async function gainAble(id) {
  return request({
    method: `post`,
    url: `${oldPlatform}/staff/property/resource/`+id,
    data: {}
  })
}


// 查询抄表列表
export async function getCopyList(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/rent/instrumentationMeterReadingManage/getManageListByPage`,
    data: {...params}
  })
}
// 查询抄表详细数据记录
export async function getCopyDetail(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/rent/meter/reading/getRentMeterReadingRecordListByPage`,
    data: {...params}
  })
}

// 新增抄表
export async function addRecord(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/rent/meter/reading/addRentMeterReadingRecord`,
    data: {...params}
  })
}

// 客户列表
export async function clientList(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/customer/getRentFollowRecordListByPage`,
    data: {...params}
  })
}

// 客户跟进状态列表
export async function followStatus(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/customer/follow/status/getRentFollowStatusList`,
    data: {...params}
  })
}

// 客户跟进记录列表
export async function followRecord(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/customer/follow/record/getRentFollowRecordListByPage`,
    data: {...params}
  })
}

// 房屋列表
export async function roomList(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/ma/room/list`,
    data: {...params}
  })
}

// 房屋列表详细数据
export async function roomDetail(id) {
  return request({
    method: `post`,
    url: `${oldPlatform}/ma/room/detail/`+id,
    data: {}
  })
}

// 房屋列表中的区域列表
export async function areaList(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/rent/params`,
    data: {...params}
  })
}
// 图片文件上传
export async function imgUpload(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/res/uploadMulti`,
    data: params
  })
}
// 工单列表
export async function orderList(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/repair/list`,
    data: {...params}
  })
}

// 提交工单
export async function addOrder(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/repair/add`,
    data: {...params}
  })
}

// 工单详细数据
export async function orderDetail(id) {
  return request({
    method: `post`,
    url: `${oldPlatform}/repair/detail/` + id,
    data: {}
  })
}
// 撤回工单
export async function rebackOrder(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/repair/withdraw`,
    data: {...params}
  })
}
// 处理工单
export async function dealOrder(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/repair/handle`,
    data: {...params}
  })
}

// 工单进度条
export async function orderProgress(id) {
  return request({
    method: `post`,
    url: `${oldPlatform}/repair/progress/` + id,
    data: {}
  })
}

// 物业看板部分
// 财务汇总
export async function amountSum(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/rent/statistics/getToDayAmountReceived`,
    // headers: {
    //   `Content-Type`: `application/x-www-form-urlencoded`
    // },
    data: {
      ...params
    }
  })
}
// 账单应收
export async function billsShould(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/rent/statistics/selectBillsReceivable`,
    data: {
      ...params
    }
  })
}
// 欠款账龄
export async function cumulativeAge(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/rent/statistics/selectCumulativeAging`,
    data: {
      ...params
    }
  })
}
// 未来收入趋势
export async function revenueTrend(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/rent/statistics/getFutureRevenueTrends`,
    data: {
      ...params
    }
  })
}
// 租赁汇总
export async function rentSum(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/rent/statistics/getContract`,
    data: {
      ...params
    }
  })
}
// 租赁统计
export async function rentCount(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/rent/statistics/selectLeaseStatistics`,
    data: {
      ...params
    }
  })
}
// 空置时间占比
export async function noRentPercent(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/rent/statistics/getVacancyTimeRoom`,
    data: {
      ...params
    }
  })
}
// 面积趋势(新签约面积/未来合同到期面积)
export async function newAreaTrend(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/rent/statistics/selectAreaTrend`,
    data: {
      ...params
    }
  })
}
// 费用汇总
export async function allEnergyData(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/rent/statistics/getEnergyConsumption`,
    data: {
      ...params
    }
  })
}
// 结余电费/结余水费 趋势数据
export async function restData(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/rent/statistics/getEnergyConsumptionTrend`,
    data: {
      ...params
    }
  })
}
// 工单汇总数据
export async function allOrderData(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/rent/statistics/getToMonthWorkOder`,
    data: {
      ...params
    }
  })
}
// 工单占比数据
export async function allPercentData(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/rent/statistics/getToRentAreaByWorkOder`,
    data: {
      ...params
    }
  })
}
// 工单数量趋势数据
export async function allTrendData(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/rent/statistics/getWorkOderTrend`,
    data: {
      ...params
    }
  })
}
// 工单客户满意度
export async function orderRankData(params) {
  return request({
    method: `get`,
    url: `${oldPlatform}/rent/statistics/getWorkOrderRank`,
    data: {
      ...params
    }
  })
}
